"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackProductAdded = trackProductAdded;
exports.default = void 0;

require("core-js/modules/es.object.keys.js");

var _trackingHelper = require("../trackingHelper");

/*
  This file contains events from the Zola Web Analytics tracking plan related to shop products:
  'Product Added': https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=164175519
*/
function trackProductAdded(eventData) {
  if (!eventData) {
    // eslint-disable-next-line no-console
    console.warn('Product Added event called with falsy value.');
    return;
  }

  if (Object.keys(eventData).length === 0) // eslint-disable-next-line no-console
    console.warn('Product Added event called without properties.'); // if the brand is not defined - clear it on the GTM data layer becuase we check for it to determine if the product added is a cash gift.

  if (!eventData.brand && window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      brand: undefined
    });
  }

  (0, _trackingHelper.trackEvent)('Product Added', eventData);
}

var _default = {
  trackProductAdded: trackProductAdded
};
exports.default = _default;